// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2u-Dq","log":"ModalInventoryLogs_log__uEXh3","date":"ModalInventoryLogs_date__78lKY","userName":"ModalInventoryLogs_userName__3Ej_H"};